import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import HeaderOne from "../wrappers/header/HeaderOne";
import FooterOne from "../wrappers/footer/FooterOne";
import ScrollToTop from "../components/scroll-to-top";
import Modal from "react-modal";
import { deleteFromCart } from "../store/slices/cart-slice"; // Import action to delete item
import { setCurrency } from "../store/slices/currency-slice";
import "./ggs.scss";

const LayoutOne = ({
  children,
  headerContainerClass,
  headerTop,
  headerPaddingClass,
  headerPositionClass,
}) => {
  const { cartItems } = useSelector((state) => state.cart); // Access Redux cart state
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const currency = useSelector((state) => state.currency);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");

  useEffect(() => {
    console.log("��� ~ cartItems:", currency);
  }, [currency]);
  const handleRemoveItem = (cartItemId) => {
    dispatch(deleteFromCart(cartItemId)); // Dispatch action to remove item
  };

  const handleSendEmail = () => {
    const cartDetails = cartItems.map((item) => `- ${item.name}`).join("\n");
    const emailBody = `Hi, my name is [yourName],\n\nHere are the items that I would like to get a sample of:\n\n${cartDetails}\n\nMy business is [yourBusinessName]. Feel free to call me at [yourPhoneNumber].\n\nThank you!`;
    window.location.href = `mailto:sales@healthteaboba.com?subject=Sample Request&body=${encodeURIComponent(
      emailBody,
    )}`;
  };

  return (
    <Fragment>
      {/*<HeaderOne*/}
      {/*  layout={headerContainerClass}*/}
      {/*  top={headerTop}*/}
      {/*  headerPaddingClass={headerPaddingClass}*/}
      {/*  headerPositionClass={headerPositionClass}*/}
      {/*/>*/}
      {children}
      <FooterOne
        backgroundColorClass="bg-gray"
        spaceTopClass="pt-100"
        spaceBottomClass="pb-70"
      />

      {currency.currencyName === "isMobileMenuOpen" ? null : (
        <Fragment>
          <ScrollToTop />

          {/* Floating Cart Button */}
          {cartItems.length > 0 && (
            <button
              aria-label="Open Cart Modal"
              type="button"
              className="scroll-top-cart"
              onClick={() => {
                setIsModalOpen(true);
                dispatch(setCurrency("isCartDetailsModalOpen"));
              }}
            >
              🛒({cartItems.length})
            </button>
          )}
        </Fragment>
      )}

      {/* Modal for Cart */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => {
          setIsModalOpen(false);
          dispatch(setCurrency("isCartDetailsModalClose"));
        }}
        contentLabel="Cart Modal"
        className="cart-modal"
        overlayClassName="cart-modal-overlay"
      >
        <button
          onClick={() => {
            setIsModalOpen(false);
            dispatch(setCurrency("isCartDetailsModalClose"));
          }}
          style={{
            marginTop: "2rem",
          }}
          className="close-modal-btn"
        >
          ✕
        </button>
        <h2>Your Cart</h2>
        <div>Scroll Down To Make A Payment</div>
        <div
          className="user-details-form"
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        >
          <label htmlFor="customer-name">
            Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            id="customer-name"
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            required
            placeholder="Example: James-Crewing"
          />
        </div>
        <table className="cart-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Notes</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {cartItems.map((item) => (
              <tr key={item.cartItemId}>
                <td>
                  <strong>{item.name}</strong>
                  <br />
                  <img
                    src={process.env.PUBLIC_URL + item.image}
                    alt={item.name}
                    style={{ width: "60px", marginTop: "6px" }}
                  />
                </td>
                <td>{item.quantity}</td>
                <td>
                  <div>
                    <strong>Drink Cost:</strong>
                    <span>${parseFloat(item.cost).toFixed(2)}</span>
                  </div>
                  <div>
                    <strong>Pearls:</strong>{" "}
                    {item.pearlSelections?.name || "None"}
                  </div>
                  {item.toppings?.length > 0 && (
                    <div>
                      <strong>Toppings:</strong>
                      <ul style={{ margin: 0, paddingLeft: "1rem" }}>
                        {item.toppings.map((topping) => (
                          <li key={topping.id || topping.name}>
                            {topping.name} ($
                            {parseFloat(topping.cost).toFixed(2)})
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div>
                    <strong>Total:</strong> $
                    {parseFloat(item.totalPrice).toFixed(2)}
                  </div>
                </td>
                <td>
                  <button
                    className="remove-item-btn"
                    onClick={() => handleRemoveItem(item.cartItemId)}
                  >
                    ✕
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="payment-section">
          <hr style={{ margin: "1.5rem 0" }} />
          <h3 style={{ marginBottom: "0.5rem", textAlign: "center" }}>
            Make a Payment
          </h3>

          <div
            style={{
              textAlign: "center",
              marginBottom: "0.75rem",
              fontWeight: "bold",
            }}
          >
            Total: $
            {cartItems
              .reduce((sum, item) => sum + parseFloat(item.totalPrice), 0)
              .toFixed(2)}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              alignItems: "center",
            }}
          >
            <button
              onClick={() =>
                window.open("https://venmo.com/u/lovellatagaca", "_blank")
              }
              className="payment-button"
            >
              <span role="img" aria-label="Venmo">
                📲
              </span>{" "}
              Pay with <strong>Venmo</strong>
            </button>

            <button
              onClick={() =>
                alert("Please send payment via Zelle to: 6612014244")
              }
              className="payment-button"
            >
              <span role="img" aria-label="Zelle">
                💸
              </span>{" "}
              Pay with <strong>Zelle at 6612014244</strong>
            </button>

            <button
              onClick={() => alert("Send payment via Apple Pay to: 6612014244")}
              className="payment-button"
            >
              <span role="img" aria-label="Apple Pay">
                🍎
              </span>{" "}
              Pay with <strong>Apple Pay</strong>
            </button>
          </div>
          <div
            style={{
              marginTop: "1rem",
              fontSize: "0.9rem",
              color: "#888",
              textAlign: "center",
            }}
          >
            Once you've paid, we’ll verify and confirm your order manually.
          </div>
          <button
            onClick={() => {
              const total = cartItems.reduce(
                (sum, item) => sum + parseFloat(item.totalPrice),
                0,
              );
              const itemDetails = cartItems
                .map((item) => {
                  const toppings =
                    item.toppings?.map((t) => t.name).join(", ") || "None";
                  return `• ${item.name} x${item.quantity} (Pearls: ${item.pearlSelections?.name || "None"}, Toppings: ${toppings})`;
                })
                .join("\n");

              const message = `Hi, this is ${customerName || "[Your Name]"}${
                customerPhone ? " (" + customerPhone + ")" : ""
              }. I’ve completed my payment.\n\nOrder:\n${itemDetails}\n\nTotal: $${total.toFixed(
                2,
              )}`;

              window.location.href = `sms:6612014244?body=${encodeURIComponent(message)}`;
            }}
            className="payment-button"
            style={{
              marginTop: "1rem",
              backgroundColor: !customerName ? "red" : "#4CAF50",
              color: "white",
            }}
            disabled={!customerName}
          >
            {customerName
              ? `✅ I Have Paid — Send Confirmation Text`
              : "Please enter your name before you can send confirmation text"}
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};

LayoutOne.propTypes = {
  children: PropTypes.node,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  headerTop: PropTypes.string,
};

export default LayoutOne;
